import { Link } from 'react-router-dom'
import * as React from 'react'
import styled from 'styled-components'

import { Button } from '../../atoms/Button'
import { Content } from '../../atoms/Content/index'
import { MenuPage } from '../MenuPage'
import { P } from '../../atoms/P'
import { media } from '../../utils/media'
import Image from '../../atoms/Image'
import { intakeMetrics } from '../../organisms/Intakes/intakeMetrics/calcIntakeMetrics'
import {Redirect} from 'react-router'
// import {ReadButton} from '../../atoms/ReadButton'
const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

const translations = {
  'en': {
    welcomeBack: 'Welcome back!',
    welcomeBackH2:  'We saved all of your information - so you can pick up where you left off',
    welcomeBackp1: 'You will not have to answer any of the questions you filled out the first time!',
    welcomeBackp2: 'You will be able to log in for 10 days after your child\'s surgery, so you can check back in as many times as you\'d like until then. And remember, you\'ll be able to print out all of the information you\'ve learned here by clicking on print in the top menu and choosing the section you\'d like to print.\n',
    welcomeBackMobile: 'just click the \'start\' button to begin at the Home Before Surgery section.',
    start: 'START',

  },
  'es': {
    welcomeBack: '¡Bienvenido de nuevo!\n',
    welcomeBackH2:  'Guardamos toda su información, para que pueda continuar donde se quedó.',
    welcomeBackp1: '¡No tendrá que responder ninguna de las preguntas que llenó la primera vez!',
    welcomeBackp2: 'Usted podrá usar el programa por 10 días después de la cirugía de su hijo. Puede iniciar y terminar sesión cuantas veces lo desee. Recuerde, puede imprimir toda la información que haya aprendido. ',
    welcomeBackMobile: 'haga clic en imprimir en el menú de arriba y elija la sección que desee imprimir. Para regresar a donde se quedó, haga clic en el botón ',
    start: 'continuar',

  },
}
export class WelcomeBackPage extends MenuPage {


  public renderContent(intake: any) {

    console.log(this.props)
    const {
      section1Started,
      section2Started,
      section3Started,
      section4Started,
      section4ReviewCompleted,
      furthestContentPage,
      furthestWebinfoPage,
      hasAcceptedDisclaimer,
    } = intakeMetrics(intake)


    let pageName = lang === 'es' ? 'Para comenzar en la sección Inicio antes de la cirugía' : 'To begin at the Home Before Surgery section'

    let startLink = '/'

    if (!window.location.host.includes('webinfo')) {
      startLink = !section1Started ? '/intake-1' : '/contents/01'
      if (section4Started) {
        startLink = '/contents/38'
        pageName = lang === 'es' ? 'Para comenzar en la sección Inicio después de la cirugía' : 'To begin at the Home After Surgery section'
      } else if (section3Started) {
        startLink = '/contents/30'
        pageName = lang === 'es' ? 'Para comenzar en la sección de Recuperación' : 'To begin at the Recovery section'
      } else if (section2Started) {
        startLink = '/contents/19'
        pageName = lang === 'es' ? 'para comenzar en la sección de cirugía' : 'To begin at the Surgery section'
      }

      if (furthestContentPage) {
        startLink = furthestContentPage
      }

      console.log(furthestContentPage)

      if(hasAcceptedDisclaimer === false){
        return (
          <Redirect to={'/contents/disclaimer-webtips'} />
        )
      }

      if(!section1Started){
        return (
          <Redirect to={startLink} />
        )
      }
    }

    if (window.location.host.includes('webinfo')) {

      startLink = '/contents/webinfo-01'

      pageName = lang === 'es' ? 'para comenzar donde lo dejaste' : 'To begin where you left off'

      if(hasAcceptedDisclaimer === false){
        return (
          <Redirect to={'/contents/disclaimer-webinfo'} />
        )
      }

      if (furthestWebinfoPage) {
        startLink = furthestWebinfoPage

      }else{
        return (
          <Redirect to={startLink} />
        )
      }
    }

    return (
      <Content>
        <RowTablet>
          <WelcomeBackImg usePng name="welcome-back_ES" />

          <ColRight>
            <H1>{translations[lang].welcomeBack}</H1>
            <H2>{translations[lang].welcomeBackH2}</H2>
            <P>{translations[lang].welcomeBackp1}</P>
            <P>
              {translations[lang].welcomeBackp2}
            </P>

            <WelcomeBackImgMobile userPng name="welcome-back_ES" />
            <P>
              {pageName}, {translations[lang].welcomeBackMobile}.
            </P>
            <ButtonContainer>
              <Link to={startLink}><Button>{translations[lang].start}</Button></Link>
            </ButtonContainer>
          </ColRight>
        </RowTablet>
      </Content>
    )
  }
}

const RowTablet = styled.div`
  margin-top: 12px;
  ${media.tablet`
    display: flex;
    align-items: center;
  `}
`

const WelcomeBackImg = styled(Image)`
  display: none;

  ${media.tablet`
    flex: 0 0 auto;
    display: block;
  `}
`

const WelcomeBackImgMobile = styled(Image)`
  flex: 0 0 auto;
  display: block;
  ${media.tablet`
    display: none;
  `}
`

const ColRight = styled.div`
  flex: 1 1 auto;
  margin-bottom: 30px;
`

const H1 = styled.h1`
  font-family: Nunito;
  font-weight: 900;
  font-size: 35px;
  color: #12385b;

  ${media.tablet`
    font-size: 54px;
  `}
`

const H2 = styled.h2`
  font-family: Nunito;
  font-size: 20px;
  font-weight: 600;
  color: #12385b;

  ${media.tablet`
    font-size: 24px;
  `}
`

const ButtonContainer = styled.div`
  margin-top: 40px;
  text-align: center;

  ${media.tablet`
    text-align: left;
  `}
`



// WEBPACK FOOTER //
// ./src/pages/WelcomeBackPage/index.tsx